import { c as _c } from "react/compiler-runtime";
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@xefi/x-react/tooltip';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import type { SurveyHome } from '@/models/survey';
import type { SurveyTab } from '@/store/mainSlice';
import { SURVEY_STATUS } from '@/utils/constants';
import { getDefaultSurveyTab } from '@/utils/surveyTabUtils';
type EditSurveyProps = {
  survey: SurveyHome;
  setSurveyTab: (value: SurveyTab) => void;
};
export const EditSurvey = t0 => {
  const $ = _c(9);
  const {
    survey,
    setSurveyTab
  } = t0;
  const {
    t
  } = useTranslation();
  const router = useRouter();
  let t1;
  if ($[0] !== router || $[1] !== setSurveyTab || $[2] !== survey.entries_count || $[3] !== survey.gates.authorizedToUpdate || $[4] !== survey.id || $[5] !== survey.status || $[6] !== survey.type || $[7] !== t) {
    t1 = !survey.gates.authorizedToUpdate || survey.status.label === SURVEY_STATUS.CLOSED ? <button className="flex size-8 cursor-not-allowed items-center justify-center rounded-md opacity-40" disabled={true} onClick={_temp}><FontAwesomeIcon size="lg" icon={faEdit} /></button> : <Tooltip content={t("edit", {
      ns: "common"
    })} placement="top" size="sm" trigger={<button className="flex size-8 cursor-pointer items-center justify-center rounded-md transition-colors" onClick={event_0 => {
      event_0.stopPropagation();
      setSurveyTab(getDefaultSurveyTab(survey.entries_count));
      const params = new URLSearchParams();
      if (survey.type?.slug) {
        params.set("type", survey.type.slug);
      }
      params.set("sId", survey.id);
      router?.push(`/survey?${params.toString()}`);
    }}><FontAwesomeIcon size="lg" icon={faEdit} /></button>} />;
    $[0] = router;
    $[1] = setSurveyTab;
    $[2] = survey.entries_count;
    $[3] = survey.gates.authorizedToUpdate;
    $[4] = survey.id;
    $[5] = survey.status;
    $[6] = survey.type;
    $[7] = t;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};
function _temp(event) {
  return event.stopPropagation();
}